import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import Header from '../Header/Header';
import Menu from '../Menu/Menu';
import './Home.css'
import v1 from "../../img/v1.jpg";
import Iframe from 'react-iframe';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import "animate.css/animate.min.css";
import AOS from "aos";
import "aos/dist/aos.css";

const Home = () => {
    useEffect(() => {
        AOS.init({
          // duration : 5000
        });
      }, []);
    return (
        <div>
            <Menu></Menu>
            <div className="home">
                <Header></Header>
               <div className='mt-3 px-lg-5 mx-lg-5 padding-left'>
                    <h2 className='heading'>PROPER Design & Development Limited</h2>
                    <hr className='w-50 mx-auto'></hr>
                    <h5>
                    <strong>PROPER Design & Development Limited</strong> is well known and excellence work holder about civil engineering Sector in Bangladesh. Our company offers a breadth of multi-discipline professional services that accounts for design, engineering, procurement and support services for all facets of industry. Specially we are conducts Land Survey and soil test(Field test & laboratory test) all over Bangladesh publicly and Privately. We prominence on safety, creativity and sustainability in our regular performance to cultivate design excellence and setting a high standard in meeting customer expectations.<br></br>  
                    <NavLink to="/about" className="text-decoration-none p-0">
                        <button className='btn button mt-3 px-5 mb-3 text-light'>About Us &gt;</button>
                    </NavLink>
                    </h5>
               </div>

               <div className='mt-5 px-lg-5 mx-lg-5 padding-left d-flex justify-content-between'>
                    <div className=' shadow mb-5 py-3 px-4' data-aos="fade-right"
                        data-aos-offset="300"
                        data-aos-easing="ease-in-sine">
                            <h2 className='heading d-flex justify-content-start'>VISION</h2>
                            <hr className='w-25'></hr>
                            <h5>
                            Quality Our Vision. Commitment of this firm is to ensure the quality full Engineering service at the level of International Standard.<br></br>  
                            </h5>
                    </div>
                    <div className=' mb-5 shadow py-3 px-4 ms-3' data-aos="fade-left"
                        data-aos-offset="300"
                        data-aos-easing="ease-in-sine">
                            <h2 className='heading d-flex justify-content-start'>MISSION</h2>
                            <hr className='w-25'></hr>
                            <h5>
                            Our mission is to be the fundamental resource for Business Intelligence, Measurement, Knowledge, and tools that are used systematically for achieving higher levels of market performance and stakeholder value.<br></br>  
                            </h5>
                    </div>
                </div>

                <div className='mt-3 px-lg-5 padding-left'>
                    <h2 className='heading'>Our Team</h2>
                    <hr className='w-50 mx-auto'></hr>
                    <div className='mt-5 pt-2'>
                    <div className="box">
                        <div class="card" data-aos="zoom-in" data-aos-offset="300"
                        data-aos-easing="ease-in-sine">
                            <div class="imgBx">
                                <img src="https://images.unsplash.com/photo-1532123675048-773bd75df1b4?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60" alt="images"/>
                            </div>
                            <div class="details">
                                <h2>SomeOne Famous<br></br><span>Chairman</span></h2>
                            </div>
                        </div>
                        
                        <div class="card" data-aos="zoom-in" data-aos-offset="300"
                        data-aos-easing="ease-in-sine">
                            <div class="imgBx">
                                <img src="https://images.unsplash.com/photo-1549417229-aa67d3263c09?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60" alt="images"/>
                            </div>
                            <div class="details">
                                <h2>SomeOne Famous<br></br><span>Deputy Director</span></h2>
                            </div>
                        </div>

                        <div class="card" data-aos="zoom-in" data-aos-offset="300"
                        data-aos-easing="ease-in-sine">
                            <div class="imgBx">
                                <img src="https://images.unsplash.com/photo-1548094878-84ced0f6896d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60" alt="images"/>
                            </div>
                            <div class="details">
                                <h2>SomeOne Famous<br></br><span>Deputy Director</span></h2>
                            </div>
                        </div>
                    
                    </div>
                 </div>
               </div>

               <div className='mt-5 px-lg-5 padding-left pt-3' id="contact">
                    <h2 className='heading'>Contact Us</h2>
                    <hr className='w-50 mx-auto'></hr>
                    <div className="row border mb-5 mx-lg-4">
                        <div className="col-lg-5 col-md-4 col-sm-12 text-dark contact mt-5" data-aos="fade-down" data-aos-offset="300"
                        data-aos-easing="ease-in-sine">
                            <img src={v1} alt="" width="100%"/>
                        </div>
                        <div className="col-lg-7 col-md-8 col-sm-12 text-secondary mt-5 pe-lg-5">
                            <h3 className='heading2'>PROPER Design & Development Limited</h3>
                            <h6 className="form">
                                9th Floor, Mukto Bangla Shoping Complex,
                                Mirpur-1, Dhaka-1216, Bangladesh. <br></br>
                                Help Line: +88018-86715960, +88017-64715960  <br></br>
                                E-mail: pddl.bd20@gmail.com  <br></br>
                                Web: www………..com
                            </h6>
                            <Iframe src="https://maps.google.com/maps?q=muktobangla%20shopping&t=&z=13&ie=UTF8&iwloc=&output=embed" width="600" height="250" style={{border:"0"}} allowfullscreen="" loading="lazy" className='map mb-5'></Iframe>
                    
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default Home;
